export default "__VITE_ASSET__C0QkxbN0__"